import {
  CmpPjtInfo,
  CpntAttrStatus,
  GetComponentProjectResponse,
  GetStupTaskCtgries,
  GetStupTasks,
  RelatedIfPjts,
  StupTckts,
} from "../../services/component-project";
import { Option } from "../../util/option";
import { ErrorSpreadsheetResult } from "../../util";

export type ComponentProjectDetailPageState = {
  searchResult: GetComponentProjectResponse;
  dataList: DataList;
  projectInformation: CmpPjtInfo;
  stakeholders: Stakeholders;
  componentAttributeStatus: CpntAttrStatus;
  primarySortingCompletionFlag: boolean;
  secondarySortingCompletionFlag: boolean;
};

export type RelatedIdfSpreadsheetState = {
  relatedIdfProjectList: RelatedIdfSpreadsheetRow[];
  dataList: DataList;
};

export type ProtocolListSpreadsheetState = {
  protocolList: ProtocolSpreadsheetRow[];
  dataList: DataList;
};

export type TaskListLv5SpreadsheetState = {
  taskList: TaskLv5SpreadsheetRow[];
  dataList: DataList;
  necFlgCell: NecFlgCell;
};

export type TaskListSpreadsheetState = {
  taskList: TaskSpreadsheetRow[];
  dataList: DataList;
  necFlgCell: NecFlgCell;
};

export type TaskStatusSpreadsheetState = {
  taskStatusList: TaskStatusSpreadsheetRow[];
  dataList: DataList;
};

export type RelatedIdfSpreadsheetRow = RelatedProjectInfo &
  ErrorSpreadsheetResult;

export type ProtocolSpreadsheetRow = SetupTaskCategoryInfo &
  ErrorSpreadsheetResult;

export type TaskLv5SpreadsheetRow = TaskInfo & ErrorSpreadsheetResult;

export type TaskSpreadsheetRow = TaskInfo & ErrorSpreadsheetResult;

export type TaskStatusSpreadsheetRow = TaskStatusInfo & ErrorSpreadsheetResult;

export type RelatedProjectInfo = {
  relatedIfPjts: RelatedIfPjts;
};

export type SetupTaskCategoryInfo = {
  isEdited: boolean;
  stupTaskCtgries: GetStupTaskCtgries;
};

export type TaskInfo = {
  isEdited: boolean;
  idx: number;
  task: GetStupTasks;
};

export type TaskStatusInfo = {
  taskStatus: StupTckts;
};

export type SetupTicketInfo = {
  isEdited: boolean;
  stupTckts: StupTckts;
};

export type Stakeholders = {
  dipFr: string;
  dipApp: string;
  dipInfra: string;
  bizApproval: string;
  bizInCharge: string;
  bizInfra: string;
};
export type TaskList = {
  idx: number;
  stupTasks: GetStupTasks;
};
export type DataList = {
  inDefCommonFlagType: Option[];
  roleType: Option[];
};
export type NecFlgCell = {
  [key: string]: {
    isDirty: boolean;
    initialValue: string;
    currentValue: string;
  };
};
export type PageNewState =
  | ComponentProjectDetailPageState
  | ((
      prevState: ComponentProjectDetailPageState,
    ) => ComponentProjectDetailPageState);
